import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20abstract%20geometric%20composition%20with%20warm%20golden%20and%20cream%20gradients%2C%20soft%20overlapping%20circles%20and%20flowing%20curves%2C%20clean%20corporate%20style%2C%20subtle%20depth%20with%20gentle%20highlights%2C%20luxurious%20minimalist%20atmosphere%2C%20elegant%20and%20professional%20technology%20platform%20backdrop%2C%20no%20text%20or%20text%20elements&width=1800&height=900&seq=hero-hth-2026&orientation=landscape"
          alt="qiaojzx.cn 一站式综合服务平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-8">
          <i className="ri-sparkling-line text-primary-400 text-sm"></i>
          <span className="text-background-50 text-sm font-medium">2026 全新升级 · 服务体验再进化</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
          一站式综合服务平台
          <br />
          <span className="text-primary-400">让服务触手可及</span>
        </h1>

        <p className="text-background-200 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          qiaojzx.cn 整合智能搜索、数据处理、即时通讯等多项核心服务，以技术创新驱动体验升级，为全球数百万用户提供安全、便捷、高效的在线服务解决方案。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/register-login"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-all text-base whitespace-nowrap"
          >
            立即免费注册
          </Link>
          <Link
            to="/category/platform-features"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 text-background-50 font-medium rounded-lg hover:bg-background-50/25 transition-all text-base backdrop-blur-sm border border-background-50/20 whitespace-nowrap"
          >
            了解平台功能
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto">
          {[
            { value: '500万+', label: '注册用户' },
            { value: '99.99%', label: '服务可用率' },
            { value: '180+', label: '覆盖国家' },
            { value: '2亿+', label: '日均请求' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">{stat.value}</div>
              <div className="text-background-300 text-xs mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}